var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDashboardIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.63333C0.834314 7.63333 0.7 7.49902 0.7 7.33333V1C0.7 0.834314 0.834315 0.7 0.999999 0.7H5.66667C5.83235 0.7 5.96667 0.834315 5.96667 1V7.33333C5.96667 7.49902 5.83235 7.63333 5.66667 7.63333H1ZM1 14.3C0.834314 14.3 0.7 14.1657 0.7 14V11C0.7 10.8343 0.834314 10.7 0.999999 10.7H5.66667C5.83235 10.7 5.96667 10.8343 5.96667 11V14C5.96667 14.1657 5.83235 14.3 5.66667 14.3H1ZM9.33333 14.3C9.16765 14.3 9.03333 14.1657 9.03333 14V7.66667C9.03333 7.50098 9.16765 7.36667 9.33333 7.36667H14C14.1657 7.36667 14.3 7.50098 14.3 7.66667V14C14.3 14.1657 14.1657 14.3 14 14.3H9.33333ZM9.03333 1C9.03333 0.834314 9.16765 0.7 9.33333 0.7H14C14.1657 0.7 14.3 0.834314 14.3 1V4C14.3 4.16569 14.1657 4.3 14 4.3H9.33333C9.16765 4.3 9.03333 4.16569 9.03333 4V1Z",
    stroke: "#222222",
    strokeWidth: 1.4
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboardIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard_icon.7a2f071d.svg";
export { ForwardRef as ReactComponent };